const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M11 30.9H9C9 25.1 16.6 22.1 19 21.3V18H21V22.8L20.3 23C20.2 23 11 25.6 11 30.9Z",
  fill: "#495C6B"
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M20 21C19.4 21 19 20.6 19 20V18.5C17.1 17 16 14.6 16 12V8C16 3.6 19.6 0 24 0C28.4 0 32 3.6 32 8V12C32 16.4 28.4 20 24 20C23.4 20 23 19.6 23 19C23 18.4 23.4 18 24 18C27.3 18 30 15.3 30 12V8C30 4.7 27.3 2 24 2C20.7 2 18 4.7 18 8V12C18 14.1 19 16.1 20.6 17.2L21 17.5V20C21 20.6 20.6 21 20 21Z",
  fill: "#495C6B"
});
var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M29 18H27V22H29V18Z",
  fill: "#495C6B"
});
var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M37 30.9C37 25.6 27.8 23 27.8 23L27 22.8V18H29V21.3C31.4 22.1 39 25.1 39 30.9H37Z",
  fill: "#495C6B"
});
var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M10 36V42H38V36H10ZM38 34C39.1 34 40 34.9 40 36V42C40 43.1 39.1 44 38 44H10C8.9 44 8 43.1 8 42V36C8 34.9 8.9 34 10 34H38ZM17 38C16.4 38 16 38.4 16 39C16 39.6 16.4 40 17 40C17.6 40 18 39.6 18 39C18 38.4 17.6 38 17 38ZM21 38C20.4 38 20 38.4 20 39C20 39.6 20.4 40 21 40C21.6 40 22 39.6 22 39C22 38.4 21.6 38 21 38ZM36 38H26V40H36V38ZM13 38C12.4 38 12 38.4 12 39C12 39.6 12.4 40 13 40C13.6 40 14 39.6 14 39C14 38.4 13.6 38 13 38Z",
  fill: "#495C6B"
});
var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M2 31H47",
  stroke: "#495C6B",
  strokeWidth: 2
});
var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M35 17H43",
  stroke: "#495C6B",
  strokeWidth: 2
});
var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M35 13H38",
  stroke: "#495C6B",
  strokeWidth: 2
});
var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M35 21H38",
  stroke: "#495C6B",
  strokeWidth: 2
});
var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M5 18V16H13V18H5Z",
  fill: "#495C6B"
});
var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M10 14V12H13V14H10Z",
  fill: "#495C6B"
});
var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M10 22V20H13V22H10Z",
  fill: "#495C6B"
});
var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M48 6V46C48 47.1 47.2 47.9 46.1 48H46H2C0.9 48 0 47.1 0 46V6C0 4.9 0.9 4 2 4H18V6H2V46H46V6H31V4H46C47.1 4 48 4.9 48 6Z",
  fill: "#495C6B"
});
function SvgCreate(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreate);
export default __webpack_public_path__ + "static/media/create.360e23d8.svg";
export { ForwardRef as ReactComponent };